<span>
	<app-feather-icons
		[icon]="'maximize'"
		role="button"
		(click)="toggleScreen()"
		class="status_toggle middle"
	></app-feather-icons>
</span>
